(function() {
  function fixProductTitle() {
    var selectors = [
      'h1.product__title',
      '.product__title',
      'h1[class*="product"]'
    ];
    var el = null;
    for (var i = 0; i < selectors.length; i++) {
      el = document.querySelector(selectors[i]);
      if (el) break;
    }
    if (!el) return;

    // Forzar tamaño sobreescribiendo el style inline
    el.style.setProperty('font-size', 'clamp(1.1rem, 4vw, 1.8rem)', 'important');
    el.style.setProperty('line-height', '1.1', 'important');
    el.style.setProperty('word-break', 'break-word', 'important');
    el.style.setProperty('white-space', 'normal', 'important');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixProductTitle);
  } else {
    fixProductTitle();
  }
})();
